import React, { useEffect, useState } from 'react';
import { FaTrash, FaTimes } from 'react-icons/fa';
import './filtroAgenda.css';
import Select from 'react-select';
import { DropdownIndicator, customStyles } from '~/Styles/reactSelectStyles';
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import * as api from '~/Services/Service';
import { Button, Col, Row } from 'react-bootstrap';

export default function FiltrosAgenda({
  filtros = {},
  handleChangeFiltros,
  leadsOptions = [],
  dataSelecionada,
  changeDataSelecionada,
  isOpen = true,
  onClose,
}) {
  const temCaracteristicaAtendenteCav = AuthStorage.temCaracteristica(
    caracteristicas.AtendenteCav
  );
  const listaCorretores = useSelector(state => state.corretor).listaCorretores;

  const [itensPorAba, setItensPorAba] = useState({
    leads: [{ value: '', label: 'Todos os Leads' }],
    corretores: [{ value: '', label: 'Todos os Corretores' }],
    atendentes: [{ value: '', label: 'Todos os Atendentes' }],
    etapa: [
      { value: '', label: 'Todas as Etapas' },
      { value: '1', label: 'Pendente' },
      { value: '2', label: 'Concluído' },
      { value: '3', label: 'Em Andamento' },
      { value: '4', label: 'Cancelado' },
      { value: '5', label: 'Vencido' },
    ],
    tipo_atividade: [
      { value: '', label: 'Todos os Tipos' },
      { value: '3', label: 'Tarefa' },
      { value: '5', label: 'Visita' },
    ],
  });

  const [corretorSelecionado, setCorretorSelecionado] = useState(filtros.corretor || '');
  const [atendenteSelecionado, setAtendenteSelecionado] = useState(filtros.atendente || '');
  const [leadSelecionado, setLeadSelecionado] = useState(filtros.codigo_lead || '');
  const [etapaSelecionada, setEtapaSelecionada] = useState(filtros.etapa || '');
  const [tipoAtividadeSelecionada, setTipoAtividadeSelecionada] = useState(filtros.tipo_atividade || '');


  useEffect(() => {
    const fetchCorretores = listaCorretores => {
      if (listaCorretores) {
        const corretores = listaCorretores.map(corretor => ({
          value: corretor.codigo,
          label: corretor.nome,
        }));
        return corretores;
      }
    };
    const corretores = fetchCorretores(listaCorretores);

    setItensPorAba(prev => ({
      ...prev,
      corretores,
      leads:
        leadsOptions.length > 0
          ? leadsOptions
          : [{ value: '', label: 'Todos os Usuários' }],
    }));
  }, [leadsOptions, listaCorretores]);

  useEffect(() => {
    montarAtendentesOptions();
  }, []);

  const montarAtendentesOptions = async () => {
    try {
      let response = await api.getAtendentesCAV();
      if (response) {
        const atendentes = response.map(pdv => ({
          value: pdv.codigo,
          label: pdv.descricao,
        }));
        setItensPorAba(prev => ({
          ...prev,
          atendentes: atendentes,
        }));
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const clearAllFilters = () => {
    const novoAtendente = '';
    const novoCorretor = '';
    const novoLead = '';
    const novaEtapa = '';
    const novoTipoAtividade = '';

    setAtendenteSelecionado(novoAtendente);
    setCorretorSelecionado(novoCorretor);
    setLeadSelecionado(novoLead);
    setEtapaSelecionada(novaEtapa);
    setTipoAtividadeSelecionada(novoTipoAtividade);

    handleChangeFiltros('atendente', novoAtendente);
    handleChangeFiltros('corretor', novoCorretor);
    handleChangeFiltros('codigo_lead', novoLead);
    handleChangeFiltros('etapa', novaEtapa);
    handleChangeFiltros('tipo_atividade', novoTipoAtividade);
    onClose();
  };

  const handleChangeData = date => {
    if (date && date.isValid && date.isValid()) {
      changeDataSelecionada(date);
    }
  };

  const aplicarFiltros = () => {
    handleChangeFiltros('atendente', atendenteSelecionado);
    handleChangeFiltros('corretor', corretorSelecionado);
    handleChangeFiltros('codigo_lead', leadSelecionado);
    handleChangeFiltros('etapa', etapaSelecionada);
    handleChangeFiltros('tipo_atividade', tipoAtividadeSelecionada);
    onClose();
  };


  if (!isOpen) return null;

  return (
    <>
      <div className="sidebar-overlay" onClick={onClose}></div>
      <div className="agenda-sidebar">
        <div className="sidebar-header">
          <h3>Filtros</h3>
          <button className="close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="sidebar-content">
          {temCaracteristicaAtendenteCav && (
            <>
              <div className="filter-group">
                <label className="filter-label">Atendentes</label>
                <Select
                  options={itensPorAba.atendentes || []}
                  onChange={e => setAtendenteSelecionado(e.value)}
                  placeholder={'Selecionar atendente'}
                  value={atendenteSelecionado ? itensPorAba.atendentes.find(
                    item => item.value == atendenteSelecionado
                  ) : { value: '', label: 'Todos os Atendentes' }
                  }
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                ></Select>
              </div>

              <div className="filter-group">
                <label className="filter-label">Corretores</label>
                <Select
                  options={[
                    { value: '', label: 'Todos os Corretores...' },
                    ...itensPorAba.corretores,
                  ]}
                  onChange={e => setCorretorSelecionado(e.value)}
                  value={corretorSelecionado ? itensPorAba.corretores.find(
                    item => item.value == corretorSelecionado
                  )
                    : {
                      value: '',
                      label:
                        listaCorretores.length === 0
                          ? 'Buscando...'
                          : 'Todos os Corretores',
                    }
                  }
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                  isDisabled={(listaCorretores || []).length === 0}
                ></Select>
              </div>
            </>
          )}

          <div className="filter-group">
            <label className="filter-label">Lead</label>
            <Select
              options={itensPorAba.leads}
              onChange={e => setLeadSelecionado(e.value)}
              value={leadSelecionado ? itensPorAba.leads.find(
                item => item.value == leadSelecionado
              )
                : { value: '', label: 'Todos os Leads' }
              }
              styles={customStyles}
              components={{ DropdownIndicator }}
            ></Select>
          </div>

          <div className="filter-group">
            <label className="filter-label">Etapa</label>

            <Select
              options={itensPorAba.etapa}
              onChange={e => setEtapaSelecionada(e.value)}
              value={
                etapaSelecionada
                  ? itensPorAba.etapa.find(item => item.value == etapaSelecionada)
                  : { value: '', label: 'Todas as Etapas' }
              }
              styles={customStyles}
              components={{ DropdownIndicator }}
            ></Select>
          </div>

          <div className="filter-group">
            <label className="filter-label">Tipo de Atividade</label>

            <Select
              options={itensPorAba.tipo_atividade}
              onChange={e => setTipoAtividadeSelecionada(e.value)}
              value={
                tipoAtividadeSelecionada
                  ? itensPorAba.tipo_atividade.find(
                    item => item.value == tipoAtividadeSelecionada
                  )
                  : { value: '', label: 'Todas as Atividades' }
              }
              styles={customStyles}
              components={{ DropdownIndicator }}
            ></Select>
          </div>

          <div className="filter-group">
            <label className="filter-label">Data</label>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <div className="form-group">
                <div className="pb-2 d-flex align-items-center">
                  <KeyboardDateTimePicker
                    style={{
                      display: 'block',
                      width: '100%',
                      height: 'calc(1.5em + 0.75rem + 2px)',
                      padding: '0.375rem 0.75rem',
                      fontSize: '1rem',
                      fontWeight: 400,
                      lineHeight: 1.5,
                      color: '#495057',
                      backgroundColor: '#fff',
                      backgroundClip: 'padding-box',
                      border: '1px solid #ced4da',
                      borderRadius: '0.25rem',
                    }}
                    clearable
                    clearLabel="limpar"
                    showTodayButton={true}
                    todayLabel="agora"
                    cancelLabel="cancelar"
                    invalidDateMessage="Data inválida"
                    ampm={false}
                    name="data"
                    value={dataSelecionada}
                    onChange={handleChangeData}
                    format="DD/MM/YYYY"
                    fullWidth
                  />
                </div>
              </div>
            </MuiPickersUtilsProvider>
          </div>
        </div>

        <div className="sidebar-footer">
          <Row className='justify-content-center gap-2'>
            <Col md="auto">
              <Button className='w-100' onClick={aplicarFiltros}>
                Aplicar Filtros
              </Button>
            </Col>
            <Col md="auto">
              <Button
                variant="danger"
                className="w-100" onClick={clearAllFilters}>
                <FaTrash />
                Limpar Filtros
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}
